import { Menu, styled } from '@mui/material';

const StyledMenu = styled(Menu)`
  & .MuiPaper-root {
    border-radius: 6px;
    margin-top: 8px;
    min-width: 180px;
    box-shadow:
      rgb(255, 255, 255) 0px 0px 0px 0px,
      rgba(0, 0, 0, 0.05) 0px 0px 0px 1px,
      rgba(0, 0, 0, 0.1) 0px 10px 15px -3px,
      rgba(0, 0, 0, 0.05) 0px 4px 6px -2px;
  }
  & .MuiMenu-list {
    padding: 4px 0;
  }
  & .MuiMenuItem-root {
    & .MuiSvgIcon-root {
      font-size: 18px;
      margin-right: 12px;
    }
    &:active {
      background-color: ${({ theme }) => theme.palette.action.selected};
    }
  }
`;

export default StyledMenu;
